import d from "./_createReduce.mjs";
import n from "./_xArrayReduce.mjs";
import s from "../bind.mjs";
function o(r, e, u) {
  for (var t = u.next(); !t.done; ) {
    if (e = r["@@transducer/step"](e, t.value), e && e["@@transducer/reduced"]) {
      e = e["@@transducer/value"];
      break;
    }
    t = u.next();
  }
  return r["@@transducer/result"](e);
}
function a(r, e, u, t) {
  return r["@@transducer/result"](u[t](s(r["@@transducer/step"], r), e));
}
var m = /* @__PURE__ */ d(n, a, o);
export {
  m as default
};
